import React from 'react';
import VenueForm from 'forms/VenueForm';

export default (): JSX.Element => <VenueForm />;
